import { Box, Flex, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";

const FooterTags = ({ title, array }) => {
  return (
    <Flex flexDirection={'column'} alignItems='start'>
      <Text fontWeight={"semibold"} p='5px' pb="15px"  fontSize="14px">
        {title}
      </Text>
      {array.map((ele, index) => (
        <Link to={ele.split(" ")[0]} fontSize="14px" p={'5px'} key={title + index} >
          {ele}

        </Link>
      ))}
    </Flex>
  );
};
export default FooterTags;
